import { Tabs } from '@tonic/shared/components/ui'
import { TabsList } from '@tonic/shared/components/ui'
import { TabsTrigger } from '@tonic/shared/components/ui'
import React from 'react';
import { Outlet } from 'react-router-dom';
import { useLocation, useNavigate } from 'react-router-dom';

export function SettingsLayout() {
  const location = useLocation();
  const navigate = useNavigate();

  const tabs = [
    { value: 'general', label: 'General', path: '/settings/general' },
    { value: 'security', label: 'Security', path: '/settings/security' },
    { value: 'notifications', label: 'Notifications', path: '/settings/notifications' },
    { value: 'integrations', label: 'Integrations', path: '/settings/integrations' },
  ];

  const currentTab = tabs.find(tab => location.pathname.startsWith(tab.path))?.value || 'general';

  return (
    <div className="container mx-auto py-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold">Settings</h1>
        <p className="text-muted-foreground">
          Manage your application settings and preferences
        </p>
      </div>

      <Tabs value={currentTab} onValueChange={(value) => {
        const tab = tabs.find(t => t.value === value);
        if (tab) navigate(tab.path);
      }}>
        <TabsList>
          {tabs.map(tab => (
            <TabsTrigger key={tab.value} value={tab.value}>
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>

      <div className="mt-6">
        <Outlet />
      </div>
    </div>
  );
} 
